export class EstablishmentDetail {
    public ID: number;
    public HashCode: string;
    public SchoolID: number;
    public BoardID: number;
    public MediumID: number;
    public SectionID: number;
    public CourseID: number;
    public EstablishmentDate: string = "";
    public Base64File: any = "";
    public FileExtension: any = "";
    public YearID: number;
    
}